const mypageRoutes = [
  {
    path: "/mypage",
    name: "",
    meta: {
      title: "마이페이지",
    },
    children: [
      {
        path: "edit", // /mypage/edit
        meta: {
          title: "내 정보수정",
          menuCd: "MYPAGE_EDIT",
          isDynamic: true,
        },
        component: () => import("@/views/student/mypage/MypageIndex.vue"),
      },
      {
        path: "search", // /mypage/search
        meta: {
          title: "내 정보수정",
          menuCd: "MYPAGE_SEARCH",
          isDynamic: true,
        },
        component: () => import("@/views/student/mypage/search/MypageSearchIndex.vue"),
      },
    ],
  },
];
export default mypageRoutes;
